import React, { Component } from 'react';
import { Menu, Row, Col, Button, Icon } from 'antd';
import { Layout } from 'antd';
import Slider from 'react-slick';
import Footer from './footer';
import TopMenu from '../menu';
import WrappedContactForm from './contactForm';
import ProjectSlider from './projectSlider';

import ScrollableAnchor, {goToAnchor} from 'react-scrollable-anchor';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
//const { Header, Footer, Sider, Content } = Layout;  

class Landing extends Component {
  state = {
    current: 'mail',
  }
  
  handleClick = (e) => {
    console.log('click ', e);
    this.setState({
      current: e.key,
    });
  }
  render() {
    const aboutUsSettingsDesktop = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1
    };
    const aboutUsSettingsMobile = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    const projectsSettings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
  
  
    return (
      <div className="Landing">
        <Layout>
          <TopMenu handleClick={this.handleClick} current={this.state.current} />
          <div className="banner">
            <div className="content-wrap">
              <Row gutter={40} >
                <Col sm={10} xs={24} className="align-left mobile-align-center">
                  <img className="logo" src="images/logo.png" />
                  <h3>PANGRAMIA</h3>
                  <p>Provides world-scale solutions</p>
                  <p className="details">
                  We help with business and technical architectures,  AI and Big Data solutions.  
                  </p> 
                </Col>
                <Col span={14} className="no-padding-right align-right">
                 
                  {/*<img className="mobile-hidden responsive-banner-image" src="images/banner.png"/>*/}
                </Col>
              </Row>
            </div>
          </div>
          <ScrollableAnchor id="solutions">
            <div className="products">
              <div  className="content-wrap">
                <Row gutter={40} >
                  <Col span={24}>
                    <h3 className="title">TARGET DOMAINS</h3>
                  </Col>
                </Row>
                <Row gutter={40} >
                 <Col md={8} sm={24}>
                    <div className="products-item">
                      <h5>Investment Funds</h5>
                      <p className="main-content">Evaluate business perspectives, investment portfolios, trends in Cloud, Blockchain, and Media areas.</p><br/>
                      <p className="item">Strategy, Investment, Hedging</p><br/>
                      <Button onClick={() => goToAnchor('contact-form')}>CONTACT</Button>  
                    </div>
                  </Col>

                 
                  <Col md={8} sm={24}>
                    <div className="products-item">
                      <h5>AI-Startups</h5>
                      <p className="main-content">
                      Product research, R&D, technical architectures, business architecture, decision supports</p><br/>
                      <p className="item">Architecture, Solutions, Advisements</p><br/>
                      <Button  onClick={() => goToAnchor('contact-form')}>CONTACT</Button>
                    </div>
                  </Col>
                 
                  <Col md={8} sm={24}>
                    <div className="products-item">
                      <h5>Think Tanks</h5>
                      <p className="main-content">News propagation,  Propaganda defence,  Anomaly detection, Custom crawling, Network science, Automated decision support</p><br/>
                      <p className="item">Consultancy, Algorithms</p><br/>
                      <Button onClick={() => goToAnchor('contact-form')}>CONTACT</Button>
                    </div>
                  </Col>

                </Row>
              </div>
            </div>
          </ScrollableAnchor>
      
          <ScrollableAnchor id="aboutus">
            <div className="aboutus"  >
              <div  className="content-wrap">
                <Row gutter={40} >
                  <Col span={24}>
                    <h2 className="title">ABOUT US</h2>
                     <p className="content margin-center">
                     Architect and scale Business, Cloud and AI solutions
                     </p>
                  </Col>
                </Row>
              </div>
              <div className="projects">
                <div className="content-wrap">
                  <Row gutter={40} >
                    <h3 className="title">Projects</h3>
                    <p className="content margin-center"></p>
                    <ProjectSlider {...projectsSettings} />
                  </Row>
                </div>
              </div>
            </div>
          </ScrollableAnchor>


         
          <ScrollableAnchor id="contact-form">
            <WrappedContactForm />
          </ScrollableAnchor>
          <Footer />
        </Layout>
      </div>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/Landing/index.js